import React, { memo } from 'react';

const Footer = memo(({ show = true }) => {
  const currentYear = new Date().getFullYear();
  return show ? (
    <footer>
      <p> Chouchane Med Amine . ALL RIGHTS RESERVED © {currentYear}</p>
    </footer>
  ) : null;
});

Footer.displayName = 'Footer';

export default Footer;
